import React from 'react';
import memoize from 'memoize-one';

const columns = memoize(() => [
  {
    name: 'TEMA',
    selector: 'topic',
    cell: item => item.topic?.label || item.topic_name,
    sortable: true,
    grow: '2'
  },
  {
    name: 'NECESIDAD',
    selector: 'necessity_area',
    cell: item => item.necessity_area?.label || item.necessity_area_name,
    sortable: true,
    grow: '2'
  },
  {
    name: 'NIVEL DE PROFUNDIDAD',
    selector: 'depth_level',
    cell: item => item.translated_depth_level || item.depth_level,
    sortable: true,
    grow: '1'
  },
  {
    name: 'NIVEL DE URGENCIA',
    selector: 'urgency_level',
    cell: item => item.translated_urgency_level || item.urgency_level,
    sortable: true,
    grow: '1'
  },
  {
    name: 'ADMISION',
    selector: 'course_admission',
    cell: item => (
      <p className={`mt-3 text-${item.course_admission === 'approved' ? 'primary' : 'warning'}`}>
        {item.translated_course_admission || 'Pendiente'}
      </p>
    ),
    sortable: true,
    grow: '1'
  },
  {
    name: 'ESTADO',
    selector: 'course_status',
    cell: item => item.course_status || 'No Comenzado',
    sortable: true,
    grow: '1'
  }
]);

export default columns;
